import { useIntl } from 'react-intl';
import styles from '../emergencyAlert.module.css';
import AIEduInputText from '../../../components/Input/AIEduInputText';
import AIEduPassword from '../../../components/Input/AIEduPassword';
import { showSuccessToast } from '../../../services/setup/ApiResponseHandler';

// Reusable copy handler function
const createCopyHandler = (copyFunction, formatMessage) => {
    return () => {
        copyFunction();
        showSuccessToast(formatMessage({ id: 'AI_EDU_COPIED' }));
    };
};

// Reusable icon component
const ActionIcon = ({ className, onClick, style = {} }) => (
    <i
        className={className}
        style={{ fontSize: '16px', ...style }}
        onClick={onClick}
    />
);

// Reusable input field with actions component
const InputFieldWithActions = ({ 
    inputComponent, 
    actions,
}) => (
    <div className='flex align-items-end justify-content-between'>
        {inputComponent}
        <div className='flex gap-2 align-items-center'>
            {actions.map((action, index) => {
                const iconClass = action.className;
                return (
                    <ActionIcon
                        key={index}
                        className={iconClass}
                        onClick={action.onClick}
                        style={action.style}
                    />
                );
            })}
        </div>
    </div>
);

const TagInfo = ({
    copyWebhookUrl,
    webhookUrl,
    apiKey,
    copyApiKey,
    onRegenerateApiKey,
    isEditMode = false,
}) => {
    const intl = useIntl();
    const { formatMessage: f } = intl;

    // Create copy handlers using the reusable function
    const handleCopyWebhookUrl = createCopyHandler(copyWebhookUrl, f);
    const handleCopyApiKey = createCopyHandler(copyApiKey, f);

    // Define actions for webhook URL
    const webhookActions = [
        {
            className: `pi pi-clone cursor-pointer ${isEditMode ? 'mr-5' : 'mr-4'}`,
            onClick: handleCopyWebhookUrl,
        }
    ];

    // Define actions for API key
    const apiKeyActions = [
        {
            className: `pi pi-clone cursor-pointer ${isEditMode ? 'mr-2' : 'mr-4'}`,
            onClick: handleCopyApiKey,
        },
        ...(isEditMode ? [{
            className: 'pi pi-sync cursor-pointer',
            onClick: onRegenerateApiKey,
        }] : [])
    ];

    return (
        <div className={`p-4 ${styles.tagInfo}`}>
            <InputFieldWithActions
                inputComponent={
                    <AIEduInputText
                        title='WebHook URL:'
                        value={webhookUrl}
                        disabled
                        width={'90%'}
                    />
                }
                actions={webhookActions}
            />

            <InputFieldWithActions
                inputComponent={
                    <AIEduPassword
                        title='API Key:'
                        value={apiKey}
                        toggleMask
                        feedback={false}
                        disabled
                        width={'90%'}
                    />
                }
                actions={apiKeyActions}
            />
        </div>
    );
};

export default TagInfo;
